import { memo } from "react";
import {
  Box,
  Container,
  Flex,
  HStack,
  Skeleton,
  SkeletonCircle,
  SkeletonText,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";

export const InvestmentSkeleton = memo(() => {
  const sectionBg = useColorModeValue("gray.50", "dark.900");
  const cardBg = useColorModeValue("white", "dark.50");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  return (
    <Box bg={sectionBg} minH="100vh" pt={{ base: "100px", md: "90px" }} pb={16}>
      <Container maxW="container.sm">
        <Skeleton height="18px" width="260px" borderRadius="md" mb="50px" />

        <Flex flexDir="column">
          <Skeleton
            height="34px"
            width="220px"
            borderRadius="lg"
            mx="auto"
            mb="20px"
          />

          <Box
            bg={cardBg}
            borderRadius="2xl"
            border="1px solid"
            borderColor={borderColor}
            overflow="hidden"
            mb="10px"
            p={4}
          >
            <HStack spacing={3} mb={4}>
              <SkeletonCircle size="10" />
              <SkeletonText noOfLines={2} spacing={3} flex="1" />
            </HStack>
            <Skeleton height="120px" borderRadius="xl" />
          </Box>

          <Box
            bg={cardBg}
            borderRadius="2xl"
            border="1px solid"
            borderColor={borderColor}
            p={6}
          >
            <VStack align="stretch" spacing={5}>
              <HStack spacing={3}>
                <Skeleton height="42px" flex="1" borderRadius="xl" />
                <Skeleton height="42px" flex="1" borderRadius="xl" />
              </HStack>
              <HStack spacing={3}>
                <Skeleton height="40px" flex="1" borderRadius="xl" />
                <Skeleton height="40px" width="110px" borderRadius="xl" />
              </HStack>
              <Skeleton height="56px" borderRadius="xl" />
              <Box
                border="1px solid"
                borderColor={borderColor}
                borderRadius="2xl"
                p={5}
              >
                <SkeletonText noOfLines={6} spacing={4} />
              </Box>
              <HStack spacing={3}>
                <Skeleton height="48px" flex="1" borderRadius="xl" />
                <Skeleton height="48px" flex="1" borderRadius="xl" />
              </HStack>
            </VStack>
          </Box>
        </Flex>
      </Container>
    </Box>
  );
});

InvestmentSkeleton.displayName = "InvestmentSkeleton";
